"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var panel_1 = require("../../../../components/pricing/layout/panel/panel");

var output_field_1 = require("../../../../components/pricing/text/output-field/output-field");

var constants_1 = require("../../../../theming/pricing-system/constants");

var drug_codes_formatter_1 = require("../../../../utils/formatters/drug-codes-formatter");

var drug_name_formatter_1 = require("../../../../utils/formatters/drug-name-formatter");

var form_formatter_1 = require("../../../../utils/formatters/form-formatter");

var package_type_formatter_1 = require("../../../../utils/formatters/package-type-formatter");

var strength_formatter_1 = require("../../../../utils/formatters/strength-formatter");

var halfWidthStyle = {
  flexBasis: '49%'
};
var panelViewStyle = {
  justifyContent: 'space-between'
};
var fieldRowViewStyle = {
  flexDirection: 'row',
  width: '100%'
};

var PriceLookupDrugInfoPanel = function (_super) {
  __extends(PriceLookupDrugInfoPanel, _super);

  function PriceLookupDrugInfoPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PriceLookupDrugInfoPanel.prototype.render = function () {
    var drug = this.props.drug;
    return react_1.default.createElement(panel_1.Panel, {
      heading: constants_1.PriceLookupDrugInfoPanelContent.heading,
      viewStyle: panelViewStyle
    }, react_1.default.createElement(react_native_1.View, {
      style: fieldRowViewStyle
    }, this.renderDrugNameField(drug), this.renderNdcField(drug)), react_1.default.createElement(react_native_1.View, {
      style: fieldRowViewStyle
    }, this.renderDrugTypeField(drug), this.renderDrugCodesField(drug)), react_1.default.createElement(react_native_1.View, {
      style: fieldRowViewStyle
    }, this.renderFormField(drug), this.renderStrengthField(drug)), react_1.default.createElement(react_native_1.View, {
      style: fieldRowViewStyle
    }, this.renderPackageTypeField(drug), this.renderPackageQuantityField(drug)));
  };

  PriceLookupDrugInfoPanel.prototype.renderDrugNameField = function (drug) {
    var formattedName = !drug ? constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified : drug_name_formatter_1.DrugNameFormatter.formatNames(drug.name, drug.genericName);
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.drugNameLabel,
      value: formattedName,
      isPlaceholder: !drug,
      viewStyle: halfWidthStyle,
      allowWrap: true
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderNdcField = function (drug) {
    var formattedNdc = !drug ? constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified : drug.ndc;
    var allowWrap = !drug;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.ndcLabel,
      value: formattedNdc,
      isPlaceholder: !drug,
      viewStyle: halfWidthStyle,
      allowWrap: allowWrap
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderDrugCodesField = function (drug) {
    var formattedCodes = !drug ? constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified : drug_codes_formatter_1.DrugCodesFormatter.formatCodes(drug.multiSourceCode, drug.brandNameCode);
    var allowWrap = !drug;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.drugCodesLabel,
      viewStyle: halfWidthStyle,
      value: formattedCodes,
      isPlaceholder: !drug,
      isAnimated: true,
      allowWrap: allowWrap
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderDrugTypeField = function (drug) {
    var drugTypeName = constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified;

    if (drug) {
      drugTypeName = drug.isGeneric ? constants_1.DrugTypeName.generic : constants_1.DrugTypeName.brand;
    }

    var allowWrap = !drug;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.drugTypeLabel,
      viewStyle: halfWidthStyle,
      value: drugTypeName,
      isPlaceholder: !drug,
      isAnimated: true,
      allowWrap: allowWrap
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderFormField = function (drug) {
    var formattedForm;

    if (!drug) {
      formattedForm = constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified;
    } else {
      formattedForm = form_formatter_1.FormFormatter.formatWithLongName(drug.form, this.props.drugForms);
    }

    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.formLabel,
      viewStyle: halfWidthStyle,
      value: formattedForm,
      isPlaceholder: !drug,
      isAnimated: true,
      allowWrap: true
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderStrengthField = function (drug) {
    var strength = {
      unit: drug ? drug.units : '',
      value: drug ? drug.strength : ''
    };
    var isPlaceholder = !drug;
    var formattedStrength;

    if (isPlaceholder) {
      formattedStrength = constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified;
    } else if (!strength.value) {
      formattedStrength = constants_1.PriceLookupDrugInfoPanelContent.notApplicable;
    } else {
      formattedStrength = strength_formatter_1.StrengthFormatter.format(strength);
    }

    var allowWrap = isPlaceholder;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.strengthLabel,
      viewStyle: halfWidthStyle,
      value: formattedStrength,
      isPlaceholder: isPlaceholder,
      isAnimated: true,
      allowWrap: allowWrap
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderPackageTypeField = function (drug) {
    var formattedPackageType;

    if (!drug) {
      formattedPackageType = constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified;
    } else {
      formattedPackageType = package_type_formatter_1.PackageTypeFormatter.format(drug.packageTypeCode, this.props.packageTypes);
    }

    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.packageTypeLabel,
      viewStyle: halfWidthStyle,
      value: formattedPackageType,
      isPlaceholder: !drug,
      isAnimated: true,
      allowWrap: true
    });
  };

  PriceLookupDrugInfoPanel.prototype.renderPackageQuantityField = function (drug) {
    var quantity = !drug ? constants_1.PriceLookupDrugInfoPanelContent.noDrugSpecified : drug.packageQuantity.toString();
    var allowWrap = !drug;
    return react_1.default.createElement(output_field_1.OutputField, {
      label: constants_1.PriceLookupDrugInfoPanelContent.packageQuantityLabel,
      viewStyle: halfWidthStyle,
      value: quantity,
      isPlaceholder: !drug,
      isAnimated: true,
      allowWrap: allowWrap
    });
  };

  return PriceLookupDrugInfoPanel;
}(react_1.default.Component);

exports.PriceLookupDrugInfoPanel = PriceLookupDrugInfoPanel;